import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { CUSTOMER_EXPORT_PATH } from "utils/constants/paths";

const CustomerExport = Loadable(React.lazy(() => import("./View")));

export const CustomerExportRoute: IRouteItem = {
  path: CUSTOMER_EXPORT_PATH,
  element: React.createElement(CustomerExport),
  accessKeys: ["ContentCreator", "Analyst"],
  name: "Customer Export",
  iconName: "ExportCurve",
};
